function repositionReview() {
  var templateReview = `
		<div class="content-wrapper ratings-block js-ratings-block">
			<div class="container">
				<div class="h4 homepage-group-title"> Reviews </div>
				<div class="rating-block">
						<div class="votes-wrap simple-vote">
							<div class="vote-wrap">
									<div class="vote-header">
										<span class="vote-pic">
										<span class="vote-initials" style="background-color: #000000;">
										F
										</span>
										<img src="data:image/gif;base64,R0lGODlhAQABAAD/ACwAAAAAAQABAAACADs=" data-src="//www.gravatar.com/avatar/d26dfbf184b8a49f39e3de16e6a3cb61?s=60&amp;d=blank&amp;r=g" class="" width="60" height="60" alt="Avatar of author">
										</span>
										<span class="vote-summary">
										<span class="vote-name vote-name--nowrap" data-testid="author">
										<span>FB</span>
										</span>
										<span class="vote-rating">
										<span class="stars" data-testid="authorStars">
										<span class="star star-on"></span>
										<span class="star star-on"></span>
										<span class="star star-on"></span>
										<span class="star star-on"></span>
										<span class="star star-on"></span>
										</span>
										<span class="vote-delimeter">|</span>
										<span class="vote-time" data-testid="latestContributionDate">
										10/06/2023
										</span>
										</span>
										</span>
									</div>
									<div class="vote-content" data-testid="authorText">
										They gave info on when the product I wanted would be in stock and delivered fast. Good one!
									</div>
							</div>
							<div class="vote-wrap">
									<div class="vote-header">
										<span class="vote-pic">
										<span class="vote-initials" style="background-color: #000000;">
										KD
										</span>
										<img src="data:image/gif;base64,R0lGODlhAQABAAD/ACwAAAAAAQABAAACADs=" data-src="//www.gravatar.com/avatar/994dd96e9b0d8a6078638bdd50be4893?s=60&amp;d=blank&amp;r=g" class="" width="60" height="60" alt="Avatar of author">
										</span>
										<span class="vote-summary">
										<span class="vote-name vote-name--nowrap" data-testid="author">
										<span>Karolina Duszkiewicz</span>
										</span>
										<span class="vote-rating">
										<span class="stars" data-testid="authorStars">
										<span class="star star-on"></span>
										<span class="star star-on"></span>
										<span class="star star-on"></span>
										<span class="star star-on"></span>
										<span class="star star-on"></span>
										</span>
										<span class="vote-delimeter">|</span>
										<span class="vote-time" data-testid="latestContributionDate">
										10/06/2023
										</span>
										</span>
										</span>
									</div>
									<div class="vote-content" data-testid="authorText">
										Great products and quick shipping 👌🏻
									</div>
							</div>
							<div class="vote-wrap">
									<div class="vote-header">
										<span class="vote-pic">
										<span class="vote-initials" style="background-color: #0B3C5D;">
										S
										</span>
										<img src="data:image/gif;base64,R0lGODlhAQABAAD/ACwAAAAAAQABAAACADs=" data-src="//www.gravatar.com/avatar/29844d4121bd6e6a0cde03f557179913?s=60&amp;d=blank&amp;r=g" class="" width="60" height="60" alt="Avatar of author">
										</span>
										<span class="vote-summary">
										<span class="vote-name vote-name--nowrap" data-testid="author">
										<span>Sarunas Z</span>
										</span>
										<span class="vote-rating">
										<span class="stars" data-testid="authorStars">
										<span class="star star-on"></span>
										<span class="star star-on"></span>
										<span class="star star-on"></span>
										<span class="star star-on"></span>
										<span class="star star-on"></span>
										</span>
										<span class="vote-delimeter">|</span>
										<span class="vote-time" data-testid="latestContributionDate">
										09/06/2023
										</span>
										</span>
										</span>
									</div>
									<div class="vote-content" data-testid="authorText">
										Shop at it's best as usually.
									</div>
							</div>
							<div class="vote-wrap">
									<div class="vote-header">
										<span class="vote-pic">
										<span class="vote-initials" style="background-color: #0B3C5D;">
										JL
										</span>
										<img src="data:image/gif;base64,R0lGODlhAQABAAD/ACwAAAAAAQABAAACADs=" data-src="//www.gravatar.com/avatar/1166029a79a337c7b73f9001e48d03b0?s=60&amp;d=blank&amp;r=g" class="" width="60" height="60" alt="Avatar of author">
										</span>
										<span class="vote-summary">
										<span class="vote-name vote-name--nowrap" data-testid="author">
										<span>Jensen Lekeux</span>
										</span>
										<span class="vote-rating">
										<span class="stars" data-testid="authorStars">
										<span class="star star-on"></span>
										<span class="star star-on"></span>
										<span class="star star-on"></span>
										<span class="star star-on"></span>
										<span class="star star-on"></span>
										</span>
										<span class="vote-delimeter">|</span>
										<span class="vote-time" data-testid="latestContributionDate">
										09/06/2023
										</span>
										</span>
										</span>
									</div>
									<div class="vote-content" data-testid="authorText">
										Verry satisfied in a few days delivery to Belgium and the hhc-p is nice.
									</div>
							</div>
							<div class="vote-wrap">
									<div class="vote-header">
										<span class="vote-pic">
										<span class="vote-initials" style="background-color: #0B3C5D;">
										J
										</span>
										<img src="data:image/gif;base64,R0lGODlhAQABAAD/ACwAAAAAAQABAAACADs=" data-src="//www.gravatar.com/avatar/28bc26ad6768d1743342b64f31040f2b?s=60&amp;d=blank&amp;r=g" class="" width="60" height="60" alt="Avatar of author">
										</span>
										<span class="vote-summary">
										<span class="vote-name vote-name--nowrap" data-testid="author">
										<span>JJ</span>
										</span>
										<span class="vote-rating">
										<span class="stars" data-testid="authorStars">
										<span class="star star-on"></span>
										<span class="star star-on"></span>
										<span class="star star-on"></span>
										<span class="star star-on"></span>
										<span class="star star-on"></span>
										</span>
										<span class="vote-delimeter">|</span>
										<span class="vote-time" data-testid="latestContributionDate">
										09/06/2023
										</span>
										</span>
										</span>
									</div>
									<div class="vote-content" data-testid="authorText">
										Great shop, high quality products, pretty fast delivery (5 days) and good customer service (no problem with speaking english). 10/10
									</div>
							</div>
							<div class="vote-wrap">
									<div class="vote-header">
										<span class="vote-pic">
										<span class="vote-initials" style="background-color: #3F3250;">
										E
										</span>
										<img src="data:image/gif;base64,R0lGODlhAQABAAD/ACwAAAAAAQABAAACADs=" data-src="//www.gravatar.com/avatar/87dfa2db96cb77333e4b79e459569e95?s=60&amp;d=blank&amp;r=g" class="" width="60" height="60" alt="Avatar of author">
										</span>
										<span class="vote-summary">
										<span class="vote-name vote-name--nowrap" data-testid="author">
										<span>Equality_First</span>
										</span>
										<span class="vote-rating">
										<span class="stars" data-testid="authorStars">
										<span class="star star-on"></span>
										<span class="star star-on"></span>
										<span class="star star-on"></span>
										<span class="star star-on"></span>
										<span class="star star-on"></span>
										</span>
										<span class="vote-delimeter">|</span>
										<span class="vote-time" data-testid="latestContributionDate">
										06/06/2023
										</span>
										</span>
										</span>
									</div>
									<div class="vote-content" data-testid="authorText">
										Great products and quick shipping to Sweden. The HHC-P vapes are truly revolutionizing! Straight up sativa goodness with no heaviness to mind or body.
										These are also the most potent vapes i have tried. As long as hhc get to stay legal in my country i will never buy from elsewhere again!
									</div>
							</div>
							<div class="vote-wrap">
									<div class="vote-header">
										<span class="vote-pic">
										<span class="vote-initials" style="background-color: #0B3C5D;">
										LM
										</span>
										<img src="data:image/gif;base64,R0lGODlhAQABAAD/ACwAAAAAAQABAAACADs=" data-src="//www.gravatar.com/avatar/842a07b2bc089166df2f263778662605?s=60&amp;d=blank&amp;r=g" class="" width="60" height="60" alt="Avatar of author">
										</span>
										<span class="vote-summary">
										<span class="vote-name vote-name--nowrap" data-testid="author">
										<span>Loren metikos</span>
										</span>
										<span class="vote-rating">
										<span class="stars" data-testid="authorStars">
										<span class="star star-on"></span>
										<span class="star star-on"></span>
										<span class="star star-on"></span>
										<span class="star star-on"></span>
										<span class="star star-on"></span>
										</span>
										<span class="vote-delimeter">|</span>
										<span class="vote-time" data-testid="latestContributionDate">
										05/06/2023
										</span>
										</span>
										</span>
									</div>
									<div class="vote-content" data-testid="authorText">
										Excellent canapuff flowers,Professional team and fast delivery.
									</div>
							</div>
							<div class="vote-wrap">
									<div class="vote-header">
										<span class="vote-pic">
										<span class="vote-initials" style="background-color: #FF6666;">
										BJ
										</span>
										<img src="data:image/gif;base64,R0lGODlhAQABAAD/ACwAAAAAAQABAAACADs=" data-src="//www.gravatar.com/avatar/8a22f938570348ba35dcaee0f34e9651?s=60&amp;d=blank&amp;r=g" class="" width="60" height="60" alt="Avatar of author">
										</span>
										<span class="vote-summary">
										<span class="vote-name vote-name--nowrap" data-testid="author">
										<span>Bart janik</span>
										</span>
										<span class="vote-rating">
										<span class="stars" data-testid="authorStars">
										<span class="star star-on"></span>
										<span class="star star-on"></span>
										<span class="star star-on"></span>
										<span class="star star-on"></span>
										<span class="star star-on"></span>
										</span>
										<span class="vote-delimeter">|</span>
										<span class="vote-time" data-testid="latestContributionDate">
										02/06/2023
										</span>
										</span>
										</span>
									</div>
									<div class="vote-content" data-testid="authorText">
										Excellent selection of products, i have ordered several times and have been very satisfied. Very good support team and shipping is quick. Top quality store and product. Delivered to ireland with no problems, go for it. 😉👍
									</div>
							</div>
							<div class="vote-wrap">
									<div class="vote-header">
										<span class="vote-pic">
										<span class="vote-initials" style="background-color: #4FB7B9;">
										O
										</span>
										<img src="data:image/gif;base64,R0lGODlhAQABAAD/ACwAAAAAAQABAAACADs=" data-src="//www.gravatar.com/avatar/3e0f907b87b8ecb90c9e5da95282ca98?s=60&amp;d=blank&amp;r=g" class="" width="60" height="60" alt="Avatar of author">
										</span>
										<span class="vote-summary">
										<span class="vote-name vote-name--nowrap" data-testid="author">
										<span>Olena</span>
										</span>
										<span class="vote-rating">
										<span class="stars" data-testid="authorStars">
										<span class="star star-on"></span>
										<span class="star star-on"></span>
										<span class="star star-on"></span>
										<span class="star star-on"></span>
										<span class="star star-on"></span>
										</span>
										<span class="vote-delimeter">|</span>
										<span class="vote-time" data-testid="latestContributionDate">
										01/06/2023
										</span>
										</span>
										</span>
									</div>
									<div class="vote-content" data-testid="authorText">
										Ha comprato il mio fratello un paio di prodotti e sono di ottima qualità. Ha raccontato anche a me,sono in attesa del ordine 😍
									</div>
							</div>
							<div class="vote-wrap">
									<div class="vote-header">
										<span class="vote-pic">
										<span class="vote-initials" style="background-color: #000000;">
										FB
										</span>
										<img src="data:image/gif;base64,R0lGODlhAQABAAD/ACwAAAAAAQABAAACADs=" data-src="//www.gravatar.com/avatar/69393f0b327076d7c48c5352768478c2?s=60&amp;d=blank&amp;r=g" class="" width="60" height="60" alt="Avatar of author">
										</span>
										<span class="vote-summary">
										<span class="vote-name vote-name--nowrap" data-testid="author">
										<span>Francesco Bottardi</span>
										</span>
										<span class="vote-rating">
										<span class="stars" data-testid="authorStars">
										<span class="star star-on"></span>
										<span class="star star-on"></span>
										<span class="star star-on"></span>
										<span class="star star-on"></span>
										<span class="star star-on"></span>
										</span>
										<span class="vote-delimeter">|</span>
										<span class="vote-time" data-testid="latestContributionDate">
										01/06/2023
										</span>
										</span>
										</span>
									</div>
									<div class="vote-content" data-testid="authorText">
										Analogy é stupefacente!
										Aromi fedeli all'originale
										Piacevole durante e dopo l'uso
									</div>
							</div>
							<div class="vote-wrap">
									<div class="vote-header">
										<span class="vote-pic">
										<span class="vote-initials" style="background-color: #000000;">
										M
										</span>
										<img src="data:image/gif;base64,R0lGODlhAQABAAD/ACwAAAAAAQABAAACADs=" data-src="//www.gravatar.com/avatar/73b2a11d79cedfbeff4dffd30ceb5ff0?s=60&amp;d=blank&amp;r=g" class="" width="60" height="60" alt="Avatar of author">
										</span>
										<span class="vote-summary">
										<span class="vote-name vote-name--nowrap" data-testid="author">
										<span>Moe</span>
										</span>
										<span class="vote-rating">
										<span class="stars" data-testid="authorStars">
										<span class="star star-on"></span>
										<span class="star star-on"></span>
										<span class="star star-on"></span>
										<span class="star star-on"></span>
										<span class="star star-on"></span>
										</span>
										<span class="vote-delimeter">|</span>
										<span class="vote-time" data-testid="latestContributionDate">
										27/05/2023
										</span>
										</span>
										</span>
									</div>
									<div class="vote-content" data-testid="authorText">
										Really good stuff, came to sweden with out problems, very potent
									</div>
							</div>
							<div class="vote-wrap">
									<div class="vote-header">
										<span class="vote-pic">
										<span class="vote-initials" style="background-color: #000000;">
										KD
										</span>
										<img src="data:image/gif;base64,R0lGODlhAQABAAD/ACwAAAAAAQABAAACADs=" data-src="//www.gravatar.com/avatar/994dd96e9b0d8a6078638bdd50be4893?s=60&amp;d=blank&amp;r=g" class="" width="60" height="60" alt="Avatar of author">
										</span>
										<span class="vote-summary">
										<span class="vote-name vote-name--nowrap" data-testid="author">
										<span>Karolina Duszkiewicz</span>
										</span>
										<span class="vote-rating">
										<span class="stars" data-testid="authorStars">
										<span class="star star-on"></span>
										<span class="star star-on"></span>
										<span class="star star-on"></span>
										<span class="star star-on"></span>
										<span class="star star-on"></span>
										</span>
										<span class="vote-delimeter">|</span>
										<span class="vote-time" data-testid="latestContributionDate">
										27/05/2023
										</span>
										</span>
										</span>
									</div>
									<div class="vote-content" data-testid="authorText">
										The best products ❤️
									</div>
							</div>
							<div class="vote-wrap">
									<div class="vote-header">
										<span class="vote-pic">
										<span class="vote-initials" style="background-color: #0B3C5D;">
										A
										</span>
										<img src="data:image/gif;base64,R0lGODlhAQABAAD/ACwAAAAAAQABAAACADs=" data-src="//www.gravatar.com/avatar/fdd0e1b4dbea6570a02aee7036de2f4d?s=60&amp;d=blank&amp;r=g" class="" width="60" height="60" alt="Avatar of author">
										</span>
										<span class="vote-summary">
										<span class="vote-name vote-name--nowrap" data-testid="author">
										<span>Alex</span>
										</span>
										<span class="vote-rating">
										<span class="stars" data-testid="authorStars">
										<span class="star star-on"></span>
										<span class="star star-on"></span>
										<span class="star star-on"></span>
										<span class="star star-on"></span>
										<span class="star star-on"></span>
										</span>
										<span class="vote-delimeter">|</span>
										<span class="vote-time" data-testid="latestContributionDate">
										26/05/2023
										</span>
										</span>
										</span>
									</div>
									<div class="vote-content" data-testid="authorText">
										Seems very good :) waiting for order now
									</div>
							</div>
							<div class="vote-wrap">
									<div class="vote-header">
										<span class="vote-pic">
										<span class="vote-initials" style="background-color: #4FB7B9;">
										OD
										</span>
										<img src="data:image/gif;base64,R0lGODlhAQABAAD/ACwAAAAAAQABAAACADs=" data-src="//www.gravatar.com/avatar/652cd5d3f66c0d63416ace95b137b918?s=60&amp;d=blank&amp;r=g" class="" width="60" height="60" alt="Avatar of author">
										</span>
										<span class="vote-summary">
										<span class="vote-name vote-name--nowrap" data-testid="author">
										<span>Oran Devers</span>
										</span>
										<span class="vote-rating">
										<span class="stars" data-testid="authorStars">
										<span class="star star-on"></span>
										<span class="star star-on"></span>
										<span class="star star-on"></span>
										<span class="star star-on"></span>
										<span class="star star-on"></span>
										</span>
										<span class="vote-delimeter">|</span>
										<span class="vote-time" data-testid="latestContributionDate">
										25/05/2023
										</span>
										</span>
										</span>
									</div>
									<div class="vote-content" data-testid="authorText">
										Excellent selection of products, i have ordered several times and have been very satisfied. Very good support team and shipping is quick. Top quality store and product 👍
									</div>
							</div>
							<div class="vote-wrap">
									<div class="vote-header">
										<span class="vote-pic">
										<span class="vote-initials" style="background-color: #FF6666;">
										DR
										</span>
										<img src="data:image/gif;base64,R0lGODlhAQABAAD/ACwAAAAAAQABAAACADs=" data-src="//www.gravatar.com/avatar/255d98c660a0870e382b789235c84f12?s=60&amp;d=blank&amp;r=g" class="" width="60" height="60" alt="Avatar of author">
										</span>
										<span class="vote-summary">
										<span class="vote-name vote-name--nowrap" data-testid="author">
										<span>Dawid Referda</span>
										</span>
										<span class="vote-rating">
										<span class="stars" data-testid="authorStars">
										<span class="star star-on"></span>
										<span class="star star-on"></span>
										<span class="star star-on"></span>
										<span class="star star-on"></span>
										<span class="star star-on"></span>
										</span>
										<span class="vote-delimeter">|</span>
										<span class="vote-time" data-testid="latestContributionDate">
										25/05/2023
										</span>
										</span>
										</span>
									</div>
									<div class="vote-content" data-testid="authorText">
										The best shop in the world!! ❤️
									</div>
							</div>
							<div class="vote-wrap">
									<div class="vote-header">
										<span class="vote-pic">
										<span class="vote-initials" style="background-color: #3F3250;">
										N
										</span>
										<img src="data:image/gif;base64,R0lGODlhAQABAAD/ACwAAAAAAQABAAACADs=" data-src="//www.gravatar.com/avatar/55a45dd46acf16b69a779a2e41f27a0a?s=60&amp;d=blank&amp;r=g" class="" width="60" height="60" alt="Avatar of author">
										</span>
										<span class="vote-summary">
										<span class="vote-name vote-name--nowrap" data-testid="author">
										<span>NikB</span>
										</span>
										<span class="vote-rating">
										<span class="stars" data-testid="authorStars">
										<span class="star star-on"></span>
										<span class="star star-on"></span>
										<span class="star star-on"></span>
										<span class="star star-on"></span>
										<span class="star star-on"></span>
										</span>
										<span class="vote-delimeter">|</span>
										<span class="vote-time" data-testid="latestContributionDate">
										25/05/2023
										</span>
										</span>
										</span>
									</div>
									<div class="vote-content" data-testid="authorText">
										Fantastic products and after sales assistance. Very kind people. I recommend this shop. Thank you very much!
									</div>
							</div>
						</div>
						<div id="ratingWrapper" class="rate-wrapper unveil-wrapper">
							<div class="rate-wrap row">
									<div class="rate-average-wrap col-xs-12 col-sm-6">
										<div class="rate-average-inner">
												<span class="rate-average">
												5,0
												</span>
												<span class="rate-star-wrap">
												<span class="stars">
												<a class="star star-on"></a>
												<a class="star star-on"></a>
												<a class="star star-on"></a>
												<a class="star star-on"></a>
												<a class="star star-on"></a>
												</span>
												<span class="stars-label">
												447 ratings
												</span>
												</span>
										</div>
										<a href="/store-rating" class="add-comment">
										<span class="link-like rating-icon">Add rating</span>
										</a>
									</div>
									<div class="col-xs-12 col-sm-6">
										<div class="rate-list" data-score="5">
												<div class="rate-star stars">
													<span class="rate-value">
													5
													</span>
													<span class="star star-off"></span>
												</div>
												<div class="rate-block">
													<span class="rate-bar" style="width: 98%;">
													<span class="rate-count active">437x</span>
													</span>
												</div>
										</div>
										<div class="rate-list" data-score="4">
												<div class="rate-star stars">
													<span class="rate-value">
													4
													</span>
													<span class="star star-off"></span>
												</div>
												<div class="rate-block">
													<span class="rate-bar" style="width: 2%;">
													<span class="rate-count active">8x</span>
													</span>
												</div>
										</div>
										<div class="rate-list" data-score="3">
												<div class="rate-star stars">
													<span class="rate-value">
													3
													</span>
													<span class="star star-off"></span>
												</div>
												<div class="rate-block">
													<span class="rate-bar" style="width: 0%;">
													<span class="rate-count">1x</span>
													</span>
												</div>
										</div>
										<div class="rate-list" data-score="2">
												<div class="rate-star stars">
													<span class="rate-value">
													2
													</span>
													<span class="star star-off"></span>
												</div>
												<div class="rate-block">
													<span class="rate-bar" style="width: 0%;">
													<span class="rate-count">0x</span>
													</span>
												</div>
										</div>
										<div class="rate-list" data-score="1">
												<div class="rate-star stars">
													<span class="rate-value">
													1
													</span>
													<span class="star star-off"></span>
												</div>
												<div class="rate-block">
													<span class="rate-bar" style="width: 0%;">
													<span class="rate-count">1x</span>
													</span>
												</div>
										</div>
									</div>
							</div>
						</div>
				</div>
			</div>
		</div>
	`;

  $(templateReview).insertBefore(".container--bannersBenefit");

  $(".js-ratings-block .homepage-group-title").wrapInner("<span></span>");
  $(".rate-average-inner .rate-star-wrap").append($(".add-comment"));
  $(".add-comment span").text("Add review");
  $(".vote-wrap").each(function () {
    $(this).append($(this).find(".vote-rating"));
  });
  $(".rate-list").each(function () {
    $(this).find(".rate-block").append($(this).find(".rate-count"));
  });
}
